<template>
	<div class="home">
		
		<el-container>
		  <el-header>
			  <el-row class="navigationHead">
				<el-col :span="4" class="navigationHead-title">
					<el-image src="/poly.png"></el-image>
				</el-col>
				<el-col :span="5" :offset="15" class="username">
					<span>{{userName}}</span>
					<span @click="exit">退出</span>
				</el-col>
			</el-row>
		  </el-header>
		  <el-container>
		    <el-aside width="200px">
				<el-menu
					style="min-height: 100vh;"
					default-active="1"
					class="el-menu-vertical-demo"
					background-color="#212A35"
					text-color="#fff"
					active-text-color="#03A4FF">
					<el-menu-item index="1" @click="contentAdmin">
					    <span slot="title">{{list[0].menuName}}</span>
					</el-menu-item>
					<el-menu-item index="2" @click="imageAdmin">
				        <span slot="title">{{list[1].menuName}}</span>
					</el-menu-item>
					<el-menu-item index="3" @click="messageAdmin">
				        <span slot="title">{{list[2].menuName}}</span>
					</el-menu-item>
					<el-menu-item index="4" @click="userAdmin" v-if="isuser">
				        <span slot="title">{{list[3].menuName}}</span>
					</el-menu-item>
				</el-menu></el-aside>
		    <el-main style="background-color: #F2F2F2;">
				<el-row>
				<el-row v-if="admin==1" class="right">
					<ContentAdmin></ContentAdmin>
				</el-row>
				<el-row v-else-if="admin==2" class="right">
					<ImageAdmin></ImageAdmin>
				</el-row>
				<el-row v-else-if="admin==3" class="right">
					<MessageAdmin></MessageAdmin>
				</el-row>
				<el-row v-else class="right">
					<UserAdmin></UserAdmin>
				</el-row>
		</el-row>
			</el-main>
		  </el-container>
		</el-container>
		
		
		
	</div>
</template>

<script>
import { exitUser } from '@/api/index.js'

import ImageAdmin from '@/components/ImageAdmin.vue' 
import ContentAdmin from '@/components/ContentAdmin.vue' 
import MessageAdmin from '@/components/MessageAdmin.vue' 
import UserAdmin from '@/components/UserAdmin.vue' 
export default 
{
	data()
	{
		return{
			admin:1,
			userName:'',
			list:[],
			isuser:false
		}
	},
	components:
	{
		ImageAdmin,
		ContentAdmin,
		MessageAdmin,
		UserAdmin
	},
	created()
	{
		this.list=JSON.parse(localStorage.getItem('meau'));
		if(this.list.length>=4)
		{
			this.isuser=true;
		}
		else
		{
			this.isuser=false;
		}
		this.userName=localStorage.getItem('userName');
		if(this.userName=='')
		{
			this.$router.push('/')
		}
	},
	methods:
	{
		contentAdmin()
		{
			this.admin=1;
		},
		imageAdmin()
		{
			this.admin=2;
		},
		messageAdmin()
		{
			this.admin=3;
		},
		userAdmin()
		{
			this.admin=4;
		},
		exit()
		{
			localStorage.removeItem('userName')
			localStorage.removeItem('meau')
			exitUser()
			.then((response)=>
			{
				this.$message.success('退出成功')
				this.$router.push('/')
			})
			
		}
	}
}
</script>

<style scoped>
	.el-header{
		padding: 0px;
	}
	.el-aside 
	{
		background-color: #212A35;
	}
	.el-main{
		padding: 0px;
	}
	.navigationHead{
		width: 100%;
		height: 60px;
		background-color: #212A35;
		line-height: 60px;
		color: white;
	}
	.navigationHead-title{
		height: 60px;
	}
	.el-submenu .el-menu-item{
		min-width:0px !important;
	}
	.right{
		height: 100vh;
		background-color: #F2F2F2;
	}
	.username span{
		margin-left: 30px;
	}
</style>